import { useEffect, useRef } from "react"

const useHasMounted = (value = false) => {
  const hasMounted = useRef(value)

  useEffect(() => {
    hasMounted.current = true
  }, [])

  return { hasMounted: hasMounted.current }
}

export default useHasMounted
